import React from 'react';
import { StatusPill, type StatusPillVariant } from '@/shared/components/ui/StatusPill';

type DomainStatus = 'verified' | 'pending' | 'failed' | 'not_started' | 'partially_verified';

interface DomainStatusBadgeProps {
  /** Status do dominio */
  status: DomainStatus;
}

/**
 * Badge de status de verificacao de dominio — StatusPill shared (F62/F63):
 * cores via tokens `var(--theme-*)` (dark mode ok), dot currentColor, sem borda.
 */
const STATUS_CONFIG: Record<DomainStatus, { label: string; variant: StatusPillVariant }> = {
  verified: { label: 'Verificado', variant: 'success' },
  pending: { label: 'Pendente', variant: 'warning' },
  failed: { label: 'Falhou', variant: 'error' },
  not_started: { label: 'Nao Iniciado', variant: 'neutral' },
  partially_verified: { label: 'Parcialmente Verificado', variant: 'warning' },
};

/**
 * @example
 * ```tsx
 * <DomainStatusBadge status="verified" />
 * ```
 */
export const DomainStatusBadge: React.FC<DomainStatusBadgeProps> = ({ status }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.not_started;
  return <StatusPill variant={config.variant} label={config.label} data-testid={`domain-status-${status}`} />;
};

DomainStatusBadge.displayName = 'DomainStatusBadge';
